import React, { useState } from 'react';
import Table from 'components/Table';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import currencyFormatter from 'utils/toCurrency';
import PropTypes from 'prop-types';
import {
  Col,
  Divider,
  Form,
  Input,
  Row,
  Typography,
  message,
} from 'antd';

const TableParcialidadesSaldadas = ({
  callback,
  data,
  form,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    onChange: (_selectedRowKeys) => {
      setSelectedRowKeys(_selectedRowKeys);
    },
  };

  const columns = [
    {
      titleText: 'Mensualidad',
      dataIndex: 'mensualidad',
      key: 'mensualidad',
      render: (value) => (value === 0 ? 'Anticipo' : value),
    },
    {
      titleText: 'Fecha de pago',
      dataIndex: 'fecha_de_pago',
      key: 'fecha_de_pago',
      render: (value) => value?.format(DATE_FRONTEND_FORMAT),
    },
    {
      titleText: 'Fecha de Vencimiento',
      dataIndex: 'fecha_de_vencimiento',
      key: 'fecha_de_vencimiento',
      render: (value) => value?.format(DATE_FRONTEND_FORMAT),
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe_de_la_parcialidad',
      key: 'importe_de_la_parcialidad',
      align: 'right',
      render: (value) => currencyFormatter(value),
    },
  ];

  const handleOnRowClick = (record) => {
    const prev = data.filter((p) => p.mensualidad > record.mensualidad && p.saldado)
      .map((p) => p.id);

    if (selectedRowKeys.includes(record.id)) {
      const clone = [...selectedRowKeys];
      clone.splice(selectedRowKeys.indexOf(record.id), 1);
      setSelectedRowKeys([...prev]);
    } else {
      setSelectedRowKeys([...prev, record.id]);
    }
  };

  const onFinish = (formValues) => {
    if (!selectedRowKeys.length) {
      message.warn('Selecciona al menos una parcialidad');
      return;
    }
    callback({ ...formValues, parcialidades: selectedRowKeys });
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      style={{ width: '100%' }}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            label="Observaciones de cancelación"
            name="observaciones_de_cancelacion"
            rules={[{ required: true }]}
          >
            <Input allowClear />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left">
        <Typography.Title level={5}>Parcialidades pagadas</Typography.Title>
      </Divider>
      <Table
        allowSearch={false}
        allowSort={false}
        cols={columns}
        data={data}
        handleOnRowClick={handleOnRowClick}
        noControls
        rowKey="id"
        rowSelection={rowSelection}
        mobileColIndex={0}
      />
    </Form>
  );
};

TableParcialidadesSaldadas.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    mensualidad: PropTypes.number,
    fecha_de_pago: PropTypes.shape({}),
    fecha_de_vencimiento: PropTypes.shape({}),
    importe_de_la_parcialidad: PropTypes.number,
  })).isRequired,
  callback: PropTypes.func.isRequired,
  form: PropTypes.shape({}).isRequired,
};

export default TableParcialidadesSaldadas;
